import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { FormActions } from "../../components/common/FormActions";
import { URL_DEPARTMENTS } from "../../utils/urls";
import { API_DEPARTMENTS } from "../../utils/apis";

export const useDepartments = () => {
  const tableColumns = () => [
    ...["name", "description", "actions"].map((item) => createColumn(item)),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions
            actions={[createEditAction(URL_DEPARTMENTS, item?.id)]}
          />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_DEPARTMENTS);

  return { tableData, tableColumns, formRoute };
};

export const useDepartmentsForm = () => {
  const sections: any = [
    {
      title: `Department Details`,
      fields: [
        {
          field_name: "name",
          type: "text",
          label: `Department Name`,
          props: { required: true },
        },
        {
          field_name: "description",
          type: "textarea",
          label: `Description`,
        },
      ],
    },
  ];

  const redirect = getRegister(URL_DEPARTMENTS);

  return { sections, redirect, onSubmit: submitDepartments };
};

function submitDepartments(payload: any, id: string) {
  //  UPDATE
  if (id) {
    return {
      id,
      api: API_DEPARTMENTS,
      params: payload,
    };
  }
  // CREATE
  return {
    api: API_DEPARTMENTS,
    params: payload,
  };
}
